import FaturamentoItemService from "@/services/FaturamentoItemService";

export const faturamentoItem = {
  namespaced: true,
  state: {
    faturamentoItem: {},
  },
  actions: {
    getFaturamentoItemOData({ commit }, payload) {
      return FaturamentoItemService.GetFaturamentoItemOData(payload).then(
        (faturamentoItem) => {
          return Promise.resolve(faturamentoItem);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default faturamentoItem;
